import React from 'react';
import propTypes from 'prop-types';
import { DragLayer } from 'react-dnd';
import { STICKER_DROP, DAY_CHECKLIST } from '~/Config/DragTypes';
import StickerPreview from './StickerPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 9999,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(currentOffset, item, itemType) {
  if (itemType === STICKER_DROP) {
    if (!currentOffset) {
      return {
        display: 'none',
      };
    }

    const { x, y } = currentOffset;

    const stickerContainer = document.getElementById(`sticker-container-${item.sticker.id}`);

    let position = {};
    const boundingRect = stickerContainer.getBoundingClientRect();
    if (stickerContainer.style.transformOrigin?.includes('bottom')) {
      position = { ...position, bottom: window.innerHeight - y - boundingRect.height };
    } else if (stickerContainer.style.transformOrigin?.includes('50%')) {
      position = { ...position, top: y + boundingRect.height * 0.5 };
    } else {
      position = { ...position, top: y };
    }
    if (stickerContainer.style.transformOrigin?.includes('right')) {
      position = { ...position, right: window.innerWidth - x - boundingRect.width };
    } else if (stickerContainer.style.transformOrigin?.includes('center')) {
      position = { ...position, left: x + boundingRect.width * 0.5 };
    } else {
      position = { ...position, left: x };
    }
    let transform = stickerContainer.style.transform;

    if (item.sticker.position_version == 1) {
      position = {
        top: y,
        left: x,
      };
      let adjustmentX = 0,
        adjustmentY = 0;
      const scale = item.sticker.scale || 1;
      if (scale > 1) {
        adjustmentX = (scale - 1) * 50;
        adjustmentY = adjustmentX;
      }
      if (scale < 1) {
        adjustmentX = -(1 / scale - 1) * 25;
        adjustmentY = adjustmentX;
      }
      transform = `translate(${(adjustmentX * stickerContainer.offsetWidth) /
        100}px, ${(adjustmentY * stickerContainer.offsetHeight) / 100}px) rotate(${item.sticker
        .rotation || 0}deg) scale(${item.sticker.scale || 1})`;
    }

    return {
      transform,
      WebkitTransform: transform,
      transformOrigin: stickerContainer.style.transformOrigin,
      width: stickerContainer.offsetWidth,
      height: stickerContainer.offsetHeight,
      opacity: 0.5,
      zIndex: 9999,
      position: 'absolute',
      ...position,
    };
  }
}

function CustomDragLayer({ item, itemType, currentOffset, isDragging }) {
  if (!isDragging) {
    return null;
  }
  function renderItem(type, item) {
    switch (type) {
      case STICKER_DROP:
        return <StickerPreview item={item} />;

      case DAY_CHECKLIST:
        return null;

      default:
        return null;
    }
  }

  return (
    <div className="sticker-preview-wrapper" style={layerStyles}>
      <div className="sticker-preview-holder" style={getItemStyles(currentOffset, item, itemType)}>
        {renderItem(itemType, item)}
      </div>
    </div>
  );
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  };
}

export default DragLayer(collect)(CustomDragLayer);

CustomDragLayer.propTypes = {
  item: propTypes.object,
  itemType: propTypes.string,
  currentOffset: propTypes.any,
  isDragging: propTypes.bool,
};
